export default {
  namespaced: true,
  state: {
    previousPage: null,
    historyPage: [],
  },
  mutations: {
    SET_PREVIOUS_PAGE(state, data) {
      state.previousPage = data;
    },
    CLEAR_PREVIOUS_PAGE(state) {
      state.previousPage = null;
    },
    SET_HISTORY_PAGE(state, data) {
      state.historyPage.push(data);
    },
    CLEAR_HISTORY_PAGE(state) {
      state.historyPage = [];
    },
  },
  actions: {
    setPreviousPage({ commit }, data) {
      commit('SET_PREVIOUS_PAGE', data);
    },
    clearPreviousPage({ commit }) {
      commit('CLEAR_PREVIOUS_PAGE');
    },
    setHistoryPage({ commit }, data) {
      commit('SET_HISTORY_PAGE', data);
    },
    clearHistoryPage({ commit }) {
      commit('CLEAR_HISTORY_PAGE');
    },
  },
};
